<script setup>
import {Input, Grid} from 'digitalpower'
import {ref} from "vue";
import {show} from "@/services/notification";

const status = ref(false);
const nombre = ref('')
const apellido = ref('')
const email = ref('')
const telefono = ref('')
const mensaje = ref('')
const ip = ref('')

function submit() {
  if (status.value === true) return;
  status.value = true;

  if (!nombre.value || !apellido.value || !email.value || !telefono.value || !mensaje.value || !mensaje.value) {
    show('Debe completar todos los campos para continuar')
    status.value = false;
    return;
  }
  show('Mensaje enviado, Muchas gracias!')
  return;
}
</script>

<template>
  <section id="contacto" class="mt-3" flex flex-center>
    <form @submit.prevent="() => {}" radius-border>
      <h1 class="mb-5">Agenda una cita</h1>
      <Grid class="grid" width="300" gapped radius-border>
        <Input v-model="nombre" label="Nombre"/>
        <Input v-model="apellido" label="Apellido"/>
        <Input v-model="email" label="Email"/>
        <Input v-model="telefono" label="Telefono"/>
      </Grid>
      <Input class="mt-5" v-model="mensaje" type="textarea"
             label="Contanos dónde queda, cómo es y cuántos metros tiene el espacio que querés remodelar y por qué lo querés hacer."/>
      <Input @action="submit" class="mt-4" type="button" value="Enviar" color="white" background="var(--primary)"/>
    </form>
  </section>
</template>

<style scoped lang="scss">
section {
  height: unset;
  min-height: unset;
  background: var(--background-color);

  padding: 2em;
}

form {
  width: 90%;
  max-width: 1200px;
  min-height: 400px;

  background: white;
  padding: 2em;
}

@media screen and (max-width: 800px) {
  section {
    padding: 1em;
  }
  h1 {
    text-align: center;
    width: 100%;
  }

  .grid {
    grid-template-columns: repeat(auto-fill, 200px);
  }
}
</style>

<style>
@media screen and (max-width: 800px) {
  .grid {
    grid-template-columns: repeat(auto-fill, 100%) !important;
  }
}
</style>